import { render, staticRenderFns } from "./Observations.vue?vue&type=template&id=086aaea8&scoped=true&"
import script from "./Observations.vue?vue&type=script&lang=js&"
export * from "./Observations.vue?vue&type=script&lang=js&"
import style0 from "./Observations.vue?vue&type=style&index=0&id=086aaea8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086aaea8",
  null
  
)

export default component.exports